import api from "@/api";


//故障 - 查询润滑点
export const olitypelist = (data) => {

  return api.axss("post", `/ocm-oil-site/oil-site-type/page`, data)
}


//故障 - 所属设备
export const ocmselect = (data) => {

  return api.axss("post", "/ocm-admin/select", data)
}


//润滑点 - 指标列表
export const oilSiteDetail = (id) => {
  return api.axss("GET", "/ocm-oil-site/oil-site/detail", {}, {
    id
  })
}

//润滑点 - 验证
export const detailIsShow = (id) => {
  return api.axss("GET", "/ocm-oil-site/oil-site/detailIsShow", {}, {
    id
  })
}


//润滑点 - 指标列表
export const oilSiteGetList = (data) => {

  return api.axss("post", "/ocm-oil-site/oil-site/page",data )
}

//查详情
export const oilSiteiDentifiers = (id) => {

  return api.axss("get", `/ocm-oil-site/oil-site/identifiers?oilSiteId=${id}` )
}

//查详情
export const detailByoilSite = (id) => { //查询指标可见


  return api.axss("get", `/ocm-oil-site/oil-site-identifier-icon/detailByoilSite?oilSiteId=${id}` )
}


//确定
export const updateByTenant = (data) => { //查询指标可见


    return api.axss("post", `/ocm-oil-site/oil-site-identifier-icon/updateByoilSite`,data )
  }

  //确定
export const getNewCode = (data) => { //查询指标可见


  return api.axss("get", `/ocm-oil-site/oil-site/getNewCode`, )
}


  //点击编辑
  export const relatedInfo = (data) => { 
    return api.axss("get", `/ocm-admin/socked/relatedInfo`,{},data )
  }
  
  
  //点击关闭
  export const sockedDel = (data) => { 
    return api.axss("get", `/ocm-admin/socked/del`,{},data )
  }


 
  
  